// extracted by mini-css-extract-plugin
export default {"WhyTrustUsSection__note":"WhyTrustUsSection-styles__WhyTrustUsSection__note__VZbLk"};